export default [
  {
    key: 'email',
    value: '',
    label: 'メールアドレス',
    name: 'email',
    as: 'plaintext',
  },
  {
    key: 'account_name',
    value: '',
    label: 'ユーザ名',
    name: 'accountName',
    as: 'plaintext',
  },
  {
    key: 'device_name',
    value: '',
    label: 'デバイス名',
    name: 'deviceName',
    as: 'plaintext',
  },
  {
    key: 'mac',
    value: '',
    label: 'Macアドレス',
    name: 'mac',
    as: 'plaintext',
  },
  {
    key: 'gender',
    value: '',
    label: '性別',
    name: 'gender',
    as: 'plaintext',
  },
  {
    key: 'height',
    value: '',
    label: '身長',
    name: 'height',
    as: 'plaintext',
  },
  {
    key: 'weight',
    value: '',
    label: '体重',
    name: 'weight',
    comment: 'weight_range',
    as: 'plaintext',
  },
  {
    key: 'body_fat_rate',
    value: '',
    label: '体脂肪率',
    name: 'bodyFatRate',
    comment: 'body_fat_rate_range',
    as: 'plaintext',
  },
  {
    key: 'body_water_rate',
    value: '',
    label: '体水分率',
    name: 'bodyWaterRate',
    comment: 'body_water_rate_range',
    as: 'plaintext',
  },
  {
    key: 'BMR',
    value: '',
    label: '基礎代謝',
    name: 'BMR',
    comment: 'BMR_range',
    as: 'plaintext',
  },
  {
    key: 'metabolic_age',
    value: '',
    label: '体内年齢',
    name: 'metabolicAge',
    comment: 'metabolic_age_range',
    as: 'plaintext',
  },
  {
    key: 'muscle_rate',
    value: '',
    label: '骨格筋',
    name: 'muscleRate',
    comment: 'muscle_rate_range',
    as: 'plaintext',
  },
  {
    key: 'bone_mass',
    value: '',
    label: '骨量',
    name: 'boneMass',
    comment: 'bone_mass_range',
    as: 'plaintext',
  },
  {
    key: 'subcutaneous_fat',
    value: '',
    label: '皮下脂肪',
    name: 'subcutaneousFat',
    comment: 'subcutaneous_fat_range',
    as: 'plaintext',
  },
  {
    key: 'visceral_fat',
    value: '',
    label: '内臓脂肪',
    name: 'visceralFat',
    comment: 'visceral_fat_range',
    as: 'plaintext',
  },
  {
    key: 'BMI',
    value: '',
    label: 'BMI',
    name: 'BMI',
    comment: 'BMI_range',
    as: 'plaintext',
  },
  {
    key: 'muscle_mass',
    value: '',
    label: '総筋肉量',
    name: 'muscleMass',
    comment: 'muscle_mass_range',
    as: 'plaintext',
  },
  {
    key: 'protein',
    value: '',
    label: 'タンパク質',
    name: 'protein',
    comment: 'protein_range',
    as: 'plaintext',
  },
  {
    key: 'lean_body_weight',
    value: '',
    label: '除脂肪体重',
    name: 'leanBodyWeight',
    as: 'plaintext',
  },
  {
    key: 'athlete',
    value: '',
    label: 'アスリートモード',
    name: 'athlete',
    as: 'plaintext',
  },
  {
    key: 'created_at',
    value: '',
    label: '計測日時',
    name: 'createdAt',
    as: 'plaintext',
  },
]
